
/**
 * Gets position of [x,y] co-ordinate on the screen relative to the top left corner of an element
 * @param [x,y] co-ordinate of point on the screen
 * @param HTMLElement offset element
 * @returns [x,y] co-ordinate of the point relative to the top, left of the element
 */
export function relativePositionToElement(
    [clientX, clientY]: [clientX: number, clientY: number],
    element: HTMLElement
): [x: number, y: number] {
    const rect = element.getBoundingClientRect()
    return [clientX - rect.x, clientY - rect.y]
}
